import type { FaireProductEntity } from "../../entity_types/product";

export const p_cmk7txfd: FaireProductEntity = {
  token: "p_cmk7txfd",
  type: "product",
  name: "Happy Heart Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/76041627f8406f19d107360f085d190e96bfd439e49bf23d50cfadb7439856c5/1528384548.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c3a190f33e94a05ca6722aff82b22e93c45efaa46f9c356aa0e028ae45b2ed3b/1528384548.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:10.968Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
